import React from 'react';
import { reduxForm } from 'redux-form';
import get from 'lodash/get';
import cs from 'classnames';
import { connect } from 'react-redux';

import * as searchHelper from '~/misc/search';
import { form2query, query2form, weightEnum } from '../../misc/search';
import LocationInput2 from '~/components/common/LocationInput2';
import LabeledInput from '~/components/common/LabeledInput';
import CalendarInput from '~/components/common/CalendarInput';
import DeadHeadSelect from '~/components/common/DeadHeadSelectInput'
import EquipSelect from '~/components/common/EquipSelect';
import EquipSelect2 from '~/components/common/EquipSelect2';
import Button from '~/components/common/Button';
import SizeSelect from '~/components/common/SizeSelect';
import WeightSelect from '~/components/common/WeightSelect';
import Checkbox from '~/components/common/Checkbox'
import BrokersInput from '~/components/common/BrokersInput/index.js';
import LengthInput from '~/components/common/weightInput/index.js';
import { loadsSearchAction } from '~/modules/loadsSearch/actions';
import { clearRouterParams } from '~/modules/window/actions';
import { updateFromStateName } from '~/modules/geosearch/actions';
import mapDispatch from '~/misc/mapDispatch';
import config from '~/config';
import store from "~/store";

import css from './searchform.css';
import { setAlert, setAlertPop } from '~/modules/user/actions';
import { modalChange } from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import { addAlertFromOtherWhereAction } from '~/modules/alert/actions';
const isDeadHeadApplicable = (state, id) => {
  const value = get(state, ['geosearch', id, 'placeValue']);
  return get(value, 'is_city') || get(value, 'is_other');
};



const locationInputId = (props, name) => `${props.id}:${name}`;
const equipmentList = [
  { label: 'Flatbed', value: 'F' },
  { label: 'Stepdeck', value: 'SD' },
  { label: 'Van', value: 'V' },
  { label: 'Reefer', value: 'R' }
]
const ItemsList = ({ value, list, onChange }) => {
  function handleToggle(e) {
    e.stopPropagation();
    e.preventDefault();
    const toggledValue = e.currentTarget.getAttribute('data-value');
    onChange([toggledValue])
  }

  return (
    <div className={cs(css.equipmentButtonContainer)}>
      <button
        className={cs(css.buttonItem, { [css.buttonSelected]: !value.length })}
        onClick={e => { e.stopPropagation(); e.preventDefault(); onChange([]) }}
      >All Loads</button>
      {
        list.map(item => {
          return (
            <button
              className={cs(css.buttonItem, { [css.buttonSelected]: value.indexOf(item.value) !== -1 })}
              key={item.label}
              data-value={item.value}
              onClick={handleToggle}
            >{item.label}</button>
          )
        })
      }
    </div>
  )
};


const CheckBox = ({onClick, value}) => {
  return (
    <div onClick={onClick} className={css.checkWarp}>
      <div
        className={cs(css.checkBox, {
          [css.checked]: !!value,
        })}></div>
      <div className={css.checkContent}>Set Load Alerts</div>
    </div>
  );
  
}

const searchForm = (props) => {
  const inputsOptions = {
    isWhiteLabel: props.isLandingForm || props.isHugeShortForm,
    tallInput: props.isLandingForm,
    hugeInput: props.isHugeShortForm,
  };

  const isHugeShortForm = props.isHugeShortForm || null;
  
  return (
    <form className={cs(css.wrap, { [css.usualForm]: !isHugeShortForm })} data-qa='search-form'>
      <span
        className={cs({
          [css.hugeForm]: isHugeShortForm,
          [css.mainRow]: !props.isSlimForm,
        })}
      >
        {props.isRevision ? <div>
          <div className={cs(css.equipmentLabel)}>Trailer Type</div>
          <ItemsList
            {...props.fields.equipment}
            list={equipmentList}
          />
          <EquipSelect2
            input={inputsOptions}
            limit={4}
            {...props.fields.equipment}
            wrapClassName={cs(css.equipSelect, {
              [css.hugeEquip]: isHugeShortForm,
            })}
            dropDownId='equipment'
            data-qa='equipment'
            withoutAny={true}
            isRadio={true}
            isNotEquipmentLabel={true}
            placeholder='Other'
          />
        </div> : <EquipSelect
          input={inputsOptions}
          limit={4}
          {...props.fields.equipment}
          wrapClassName={cs(css.equipSelect, {
            [css.hugeEquip]: isHugeShortForm,
          })}
          label="Trailer Type"
          dropDownId='equipment'
          data-qa='equipment'
        />}

        <div
          className={cs({
            [css.inputGroup]: !isHugeShortForm,
            [css.hugeOrigin]: isHugeShortForm,
          })}
        >
          <LocationInput2
            input={inputsOptions}
            id={locationInputId(props, 'origin-field')}
            data-qa='origin'
            label='Origin'
            {...props.fields.origin}
            autoFocus={props.autoFocus}
            placeholder={get(props, 'placeholders.origin')}
            inputClassName="search-origin-input"
          />
          {/* before deadhead input component */}
          {/* <LabeledInput
            {...inputsOptions}
            label='Deadhead,mi'
            type='number'
            mediumInput
            {...props.fields.dho}
            data-qa='dho-field'
            placeholder={get(props, 'placeholders.dho') || (props.isDHOApplicable || '')}
          /> */}
          {/* now deadhead input component */}
          {!isHugeShortForm && <DeadHeadSelect {...props.fields.dho} wrapClassName={css.sizeSelect} dropDownId="deadHeadOrigin" />}
          
        </div>
        {!isHugeShortForm && <div className={cs(css.destinationInput, css.inputGroup)}>
          {<LocationInput2
            input={inputsOptions}
            id={locationInputId(props, 'destination-field')}
            data-qa='destination'
            label='Destination'
            {...props.fields.destination}
            placeholder={get(props, 'placeholders.destination')}
          />}
          {/* before deadhead input component */}
          {/* <LabeledInput
            {...inputsOptions}
            label='Deadhead,mi'
            type='number'
            {...props.fields.dhd}
            mediumInput
            data-qa='dhd-field'
            placeholder={get(props, 'placeholders.dhd') || (props.isDHDApplicable || '')}
          /> */}
          {/* now deadhead input component */}
          {!isHugeShortForm && <DeadHeadSelect {...props.fields.dhd} wrapClassName={css.sizeSelect} dropDownId="deadHeadDestination" />}
        </div>}
        <div>
          <CalendarInput
            input={inputsOptions}
            {...props.fields.date}
            data-qa='pickup'
            label='Pickup Date'
            multiSelect={true}
            wrapClassName={cs(css.datePicker, {
              [css.hugePickup]: isHugeShortForm,
            })}
            dropDownId='datePickup'
          />
        </div>
    
          <div>
            <WeightSelect {...props.fields.weight} wrapClassName={css.weightSelect} dropDownId='weightSelect' />
          </div>
          <div className={css.lengthInput}>
            <LengthInput {...props.fields.length} label="Length (ft)" />
          </div>

        {props.advanced ? (
          <SizeSelect {...props.fields.loadSize} wrapClassName={css.sizeSelect} dropDownId='sizeSelect' />
        ) : null}
        {props.advanced ? config.brokersSearch && <BrokersInput {...props.fields.dots} wrapClassName={css.brokerSelect} /> : null}
      </span>
      <span
        className={cs({
          [css.secondRow]: !props.isSlimForm,
          [css.oneLineSubmitButton]: props.isSlimForm,
          [css.tallButton]: props.isLandingForm,
          [css.hureButtonLine]: props.isHugeShortForm,
          [css.advancedFrom]: props.advanced,
        })}
      >
        <div className={css.selectConfirmBox}>

          <div className={css.checkboxGroup}>
            <CheckBox
              value={Boolean(props.isSetAlert)}
              onClick={() => {
                if(!props.isPremiumMember) {
                  if(!props.isSetAlertPoped) {
                    props.setAlertPop()
                    props.setAlertOncePopUp();
                  }else {
                    props.showUpgradeToPremium();
                  }
                  props.setAlert(false);
                }else {
                  props.setAlert(!props.isSetAlert)
                }
              }}
            ></CheckBox>
          </div>
          <Button onClick={props.handleSubmit} data-qa='find-loads' submit={true}
            wrapperClassName={css.submitButton}
            mods={[
              'action',
              props.isLandingForm && 'tall',
              props.isHugeShortForm && 'huge',
            ]}
          >
            Find Loads
          </Button>
        </div>
      </span>
    </form>
  );
};

const fields = [
  'origin',
  'dho',
  'destination',
  'dhd',
  'date',
  'equipment',
  'loadSize',
  'emptyWeight',
  'emptyLength',
  'sort_by',
  'sort_order',
  'dots', // dots is broker
  'weight',
  'length',
];

const openOnceModal = () => store.dispatch(modalChange(modes.SET_ALERT_ONCE,  {type: 'askPop'}))
const showUpgradeToPremium = () => store.dispatch(modalChange('pop', {
  source: "alert popup",
  type: 'pop_upgrade_to_premium',
}))
const reduxedForm = reduxForm(
  {
    form: 'search',
    id: 'search',
    fields,
  },
  (state, props) => ({
    anonBanerTextAndAction: config.anonBanerTextAndAction,
    initialValues: query2form(state.loadsSearch.query, props.isLandingForm),
    isDHOApplicable: isDeadHeadApplicable(state, locationInputId(props, 'origin-field')),
    isDHDApplicable: isDeadHeadApplicable(state, locationInputId(props, 'destination-field')),
    userIsLoggedIn: state.user.isLoggedIn,
    isPremiumMember: Number(state.account.accountLevel) >= Number(state.account.premium),
    isSetAlert: state.user.isSetAlert,
    isSetAlertPoped: state.user.isSetAlertPoped,
    setAlert:  (flag) => {
      store.dispatch(setAlert(flag))
    },
    setAlertPop:() => {
      store.dispatch(setAlertPop())
    },
    setAlertOncePopUp: openOnceModal,
    showUpgradeToPremium: showUpgradeToPremium
  })
)(searchForm);
/**
 * 
 * @param {Object} data location info
 * @param {String} type origin or destination
 */
const generateCityInfo = (data,type = 'from') => {
  // let obj = {
  //   city: "Los Angeles",
  //   country: "US",
  //   is_city: true,
  //   lat: 33.99,
  //   lng: -118.39,
  //   name: "Los Angeles, CA",
  //   state: "CA",
  // }
  // let generateObj = {
  //   from_city: '',
  //   from_state: '',
  //   from_country:'', 
  //   from_lng: '',
  //   from_lat: '',
  //   from_st: '',
  //   from_name: '',
  //   to_city: '',
  //   to_state: '',
  //   to_country: '',
  //   to_name: '',
  //   to_st: '',
  //   to_lng: '',
  //   to_lat: ''
  // }
  let tempObj = Object.create(null)
  Object.keys(data).forEach((key) => {
    if(key == 'city' || key == 'country' || key == 'lat' || key == 'lng' || key == 'name' || key == 'state'){
      tempObj[type+'_'+key] = data[key]
    }
  })
  return tempObj
}
const loadSizeMap = {
  'any' : 'FTL+LTL',
  'full' : 'FTL',
  'partial': 'LTL'
}
export default connect(null, mapDispatch({
  /**
   * 
   * @param {*} props 
   * @param {Object} formData
   * formData = {
   *  date: ''
      destination: undefined
      dhd: 200
      dho: 200
      dots: []
      emptyLength: true
      emptyWeight: true
      equipment: []
      length: undefined
      loadSize: "any"
      origin: undefined
      sort_by: "age"
      sort_order: "asc"
      weight: "middle"
   * }
   * @returns 
   */
  onSubmit: (props, formData) => {
    //Pre check for alert.
    // return openOnceModal();
    const {user, account,loadsSearch} = store.getState();
    const {query} = loadsSearch
    
    const isPremiumMember = Number(account.accountLevel) >= Number(account.premium)
    if(user.isSetAlert && !isPremiumMember) {
      store.dispatch(setAlert(false));
      if(!user.isSetAlertPoped) {
        store.dispatch(setAlertPop());
        return openOnceModal();
      }
      return showUpgradeToPremium();
    }
    // validate between search form data with url query is same or not first.

    // here is three situation with origin/destination value
    // 1. {name: 'Los Angeles, CA'}
    // 2. {"country": "US","state": "CA","city": "Los Angeles","lat": 33.99,"lng": -118.39,"is_city": true,"name": "Los Angeles, CA"}
    // 3. empty object
    const id = 'search:origin-field'
    const { geosearch } = store.getState();
    const info = geosearch[id] || {}
    const placeValue = info.placeValue || {}
  

    const toId = 'search:destination-field'
    const toInfo = geosearch[toId] || {}
    const toPlaceValue = toInfo.placeValue || {}

    

    // origin destination selector choosed , relative city data has saved in store
   
    
    if(user.isSetAlert && user.token) {
      console.log(placeValue, toPlaceValue, formData);
      store.dispatch(
        addAlertFromOtherWhereAction({
          origin: placeValue,
          destination: toPlaceValue,
          length: formData.length,
          loadSize: formData.loadSize ? loadSizeMap[formData.loadSize] : loadSizeMap['any'],
          weight: formData.weight
            ? weightEnum[formData.weight].max
            : weightEnum['any'].max,
          date: formData.date,
          equipment: formData.equipment,
          dho: formData.dho,
          dhd: formData.dhd,
        })
      );
    }
    // relative city of location info(lat,lng) is not neccessry
    // if location info is empty 

    const name = placeValue.name
    const dom = document.querySelector('.search-origin-input')
    const domValue = dom ? dom.value : ''
    if (props.isclearParams && (name || domValue)) {
      store.dispatch(updateFromStateName(id, ''))
      // what a clever logic f**k
      // store.dispatch(clearRouterParams(window.location.pathname))
    }

    if((placeValue && placeValue.name) || (toPlaceValue && toPlaceValue.name)){
       // placeValue, toPlaceValue
      const fromLocaionInfo = (placeValue && placeValue.name) && generateCityInfo(placeValue,'from') || {}
      const toLocationInfo = (toPlaceValue && toPlaceValue.name) && generateCityInfo(toPlaceValue,'to') || {}
      formData = Object.assign(formData,fromLocaionInfo,toLocationInfo)
    }
    if(formData && (formData.date && formData.date.length > 2)){
      const beforeDateList = formData.date;
      formData.date = [beforeDateList.shift(),beforeDateList.pop()]
    }
    return loadsSearchAction(searchHelper.coerceQueryTypes(formData))
  },
}))(reduxedForm);



// WEBPACK FOOTER //
// ./src/components/searchform/searchform.js